import { radioClasses } from "@mui/material";
const MuiRadio = {
    styleOverrides: {
        root: ({ theme })=>({
                margin: theme.spacing(0, 0.5),
                height: '32px',
                width: '32px',
                ['& svg']: {
                    height: '20px',
                    width: '20px'
                },
                [`&.${radioClasses.checked}`]: {
                    [' svg[data-testid="RadioButtonUncheckedIcon"]']: {
                        color: theme.palette.text.secondary
                    }
                },
                ['&:hover']: {
                    backgroundColor: 'light' === theme.palette.mode ? theme.palette.designSystem.grey[50] : theme.palette.designSystem.grey[700],
                    borderRadius: '4px'
                }
            })
    }
};
export { MuiRadio };

//# sourceMappingURL=radio-overrides.js.map